import { RefObject, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ComponentsDispatch } from '../store';
import { setterGant } from '../store/slices/gantSlice';

const useHeightGantContainer = (containerParentRef: RefObject<HTMLDivElement>) => {
    const dispatch = useDispatch<ComponentsDispatch>();

    const [newHeightContainer, setNewHeightContainer] = useState(0);

    useEffect(() => {
        if (!containerParentRef.current) {
            return;
        }

        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const newHeight = entry.contentRect.height + 1;
                setNewHeightContainer(newHeight);
            }
        });
        observer.observe(containerParentRef.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        dispatch(setterGant({ availableHeight: newHeightContainer }));
    }, [newHeightContainer]);

    return newHeightContainer;
};

export default useHeightGantContainer;
